import { queryOptions, useQuery } from "@tanstack/react-query";
import {
  type EnterpriseAssetsV2SummaryRequestOptions,
  fetchEnterpriseAssetsV2Summary,
} from "../api/enterpriseClient";

export const assetsV2SummaryQueryOptions = (
  customerId: number,
  options: EnterpriseAssetsV2SummaryRequestOptions = {},
) =>
  queryOptions({
    queryKey: ["enterprise-assets-v2-summary", customerId, options],
    queryFn: () => fetchEnterpriseAssetsV2Summary(customerId, options),
    staleTime: 60_000,
  });

export function useGetAssetsV2Summary(
  customerId: number,
  options: EnterpriseAssetsV2SummaryRequestOptions = {},
) {
  return useQuery(assetsV2SummaryQueryOptions(customerId, options));
}
